export const HERO_IMG = "/assets/chantier-platelage.jpg";
export const ABOUT_IMG = "/assets/chantier-coffrage.jpg";
export const WORKER_IMG = "/assets/chantier-coffrage.jpg";
export const CRANE_IMG = "/assets/chantier-facade.jpg";
export const SLAB_IMG = "/assets/chantier-plancher.jpg";
export const REBAR_IMG = "/assets/chantier-structure.jpg";

export const SERVICES = [
  {
    slug: "coffrage",
    icon: "fa-solid fa-grip",
    title: "Coffrage traditionnel & métallique",
    short: "Voiles, poteaux et poutres réalisés au cordeau, pour des ouvrages parfaitement alignés.",
    description:
      "Mise en œuvre de coffrages bois et métalliques pour voiles porteurs, poteaux et poutres en béton armé. Précision géométrique, étanchéité des banches et finition brute soignée.",
    image: "/assets/chantier-coffrage.jpg",
    bullets: [
      "Coffrage bois traditionnel pour ouvrages spécifiques",
      "Banches métalliques modulaires (haut rendement)",
      "Coffrage de poutres, poteaux, longrines",
      "Décoffrage soigné et reprise de surface",
    ],
  },
  {
    slug: "platelage",
    icon: "fa-solid fa-bars-staggered",
    title: "Platelage & mise en place de poutres",
    short: "Pose, étaiement et calage de poutres béton et préfabriquées.",
    description:
      "Platelage des planchers, étaiement, mise en place et calage des poutres porteuses. Validation des descentes de charges et sécurisation des trémies.",
    image: "/assets/chantier-platelage.jpg",
    bullets: [
      "Étaiement et platelage de planchers",
      "Pose de poutres préfabriquées et coulées en place",
      "Vérification des appuis, calage millimétrique",
      "Sécurisation des trémies et garde-corps provisoires",
    ],
  },
  {
    slug: "coffrage-plancher-gridflex",
    icon: "fa-solid fa-table-cells-large",
    title: "Coffrage plancher horizontal — GridFlex PERI",
    short: "Coffrage de planchers horizontaux avec matériel modulaire GridFlex PERI : rapide, sûr et économique.",
    description:
      "Mise en œuvre de coffrages de planchers horizontaux à l'aide du système modulaire GridFlex PERI. Une trame de poutrelles aluminium et de panneaux de coffrage qui garantit un montage rapide, une excellente planéité et une sécurité renforcée pour les compagnons. Idéal pour planchers de grande surface, dalles d'épaisseur courante à forte (jusqu'à 40 cm).",
    image: "/assets/chantier-plancher.jpg",
    bullets: [
      "Système GridFlex PERI : poutrelles GT 24 + panneaux 3-SO",
      "Étaiement par tours et étais PEP / MULTIPROP",
      "Trame régulière 75 × 150 cm — gain de productivité",
      "Conforme aux normes EN 12812 (échafaudages & étaiement)",
      "Planéité et qualité de parement supérieures",
      "Sécurité optimale : montage depuis le sol, garde-corps intégrés",
    ],
  },
  {
    slug: "planchers-beton",
    icon: "fa-solid fa-layer-group",
    title: "Planchers béton",
    short: "Dalles pleines, prédalles, poutrelles‑hourdis : tous types de planchers.",
    description:
      "Réalisation de planchers béton armé pour bâtiments neufs : dalles pleines coulées en place, planchers à prédalles précontraintes ou à poutrelles‑hourdis selon le projet.",
    image: "/assets/chantier-plancher.jpg",
    bullets: [
      "Dalles pleines coulées en place",
      "Planchers à prédalles précontraintes",
      "Planchers poutrelles‑hourdis",
      "Réservations & incorporations fluides",
    ],
  },
  {
    slug: "structures-beton",
    icon: "fa-solid fa-building",
    title: "Structures béton armé",
    short: "Montage complet de structures porteuses pour bâtiments neufs.",
    description:
      "De la fondation au gros œuvre fini : élévation des voiles, poteaux, planchers, escaliers et ouvrages spéciaux en béton armé conforme aux Eurocodes.",
    image: "/assets/chantier-structure.jpg",
    bullets: [
      "Fondations superficielles et semelles filantes",
      "Voiles porteurs, refends, poteaux",
      "Escaliers béton coulés en place",
      "Ouvrages spéciaux et reprises",
    ],
  },
  {
    slug: "maconnerie",
    icon: "fa-solid fa-trowel-bricks",
    title: "Maçonnerie gros œuvre",
    short: "Maçonnerie traditionnelle pour bâtiments neufs : agglos, briques, blocs.",
    description:
      "Murs porteurs et de remplissage, cloisons maçonnées, chaînages, linteaux. Une exécution propre, conforme aux DTU, et coordonnée avec les corps d'état.",
    image: "/assets/chantier-facade.jpg",
    bullets: [
      "Murs en agglos, blocs béton, briques",
      "Chaînages horizontaux et verticaux",
      "Linteaux, appuis, seuils",
      "Réservations & scellements",
    ],
  },
  {
    slug: "nettoyage",
    icon: "fa-solid fa-broom",
    title: "Nettoyage fin de chantier & bureaux",
    short: "Prestations de nettoyage professionnel : remise en état post-chantier, bureaux et locaux tertiaires.",
    description:
      "DCR-BATI propose un service complet de nettoyage professionnel : remise en état après travaux (gros œuvre, second œuvre, rénovation) et entretien régulier de bureaux, locaux d'activité, commerces et copropriétés. Équipes formées, matériel professionnel, produits éco-responsables et intervention en Île-de-France.",
    image: "https://images.pexels.com/photos/4239031/pexels-photo-4239031.jpeg?auto=compress&cs=tinysrgb&w=1600",
    gallery: [
      "https://images.pexels.com/photos/4239031/pexels-photo-4239031.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/4099355/pexels-photo-4099355.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/6196234/pexels-photo-6196234.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/5591581/pexels-photo-5591581.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/4099120/pexels-photo-4099120.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=1200&q=80&auto=format&fit=crop",
    ],
    bullets: [
      "Nettoyage fin de chantier (gros œuvre, second œuvre, rénovation)",
      "Évacuation des gravats et déchets de chantier",
      "Décapage, lessivage des sols, dépoussiérage des surfaces",
      "Nettoyage de bureaux, locaux tertiaires et commerces",
      "Entretien régulier ou ponctuel sur devis",
      "Produits éco-responsables & équipes formées",
    ],
  },
];

export const VALUES = [
  { title: "Qualité", text: "Exécution au cordeau, contrôles à chaque phase, finitions soignées.", icon: "fa-solid fa-medal" },
  { title: "Sécurité", text: "PPSPS, EPI, formation continue. Zéro compromis sur les chantiers.", icon: "fa-solid fa-helmet-safety" },
  { title: "Maîtrise technique", text: "Coffrage, béton armé, planchers : un savoir-faire intégré.", icon: "fa-solid fa-compass-drafting" },
  { title: "Fiabilité", text: "Respect strict des délais et engagements contractuels.", icon: "fa-solid fa-shield-halved" },
];

export const PROJECTS = [
  {
    name: "Nettoyage — Centre commercial Okabé",
    location: "Le Kremlin-Bicêtre (94)",
    type: "Nettoyage · Centre commercial",
    surface: "Fin de chantier · Remise en état",
    image: "/assets/chantier-okabe/photo-1.jpeg",
    video: "/assets/chantier-okabe/video.mp4",
    gallery: [
      "/assets/chantier-okabe/video.mp4",
      "/assets/chantier-okabe/photo-1.jpeg",
      "/assets/chantier-okabe/photo-2.jpeg",
      "/assets/chantier-okabe/photo-3.jpeg",
      "/assets/chantier-okabe/photo-4.jpeg",
    ],
    tag: "Chantier terminé",
    ctaService: "nettoyage",
    description: "Prestation de nettoyage professionnel réalisée au Centre commercial Okabé. Remise en état complète des surfaces après travaux : décapage, lessivage des sols, dépoussiérage et évacuation des déchets. Intervention en horaires décalés pour ne pas perturber l'exploitation du site.",
  },
  {
    name: "Résidence neuve — Aubervilliers",
    location: "Aubervilliers (93)",
    type: "Résidentiel · Gros œuvre",
    surface: "Coffrage · Planchers béton · Structure",
    image: "/assets/chantier-aubervilliers-fin/photo-1.jpeg",
    gallery: [
      "/assets/chantier-aubervilliers-fin/photo-1.jpeg",
      "/assets/chantier-aubervilliers-fin/photo-2.jpeg",
      "/assets/chantier-aubervilliers-fin/photo-3.jpeg",
      "/assets/chantier-aubervilliers-fin/photo-4.jpeg",
      "/assets/chantier-aubervilliers-fin/photo-5.jpeg",
      "/assets/chantier-aubervilliers-fin/photo-6.jpeg",
    ],
    tag: "Chantier terminé",
    description: "Chantier livré — fin de chantier à Aubervilliers (93). Élévation complète des structures porteuses en béton armé : coffrage des voiles, ferraillage, coulage des planchers et finitions. Livraison dans les délais, qualité d'exécution conforme au cahier des charges.",
  },
  {
    name: "Immeuble résidentiel — Paris 13e",
    location: "Paris 13 (75)",
    type: "Résidentiel · R+ étages",
    surface: "Coffrage · Façade béton",
    image: "/assets/chantier-facade.jpg",
    gallery: ["/assets/chantier-facade.jpg", "/assets/chantier-plancher.jpg"],
    tag: "Réalisé",
    description: "Réalisation des structures en béton armé et planchers étage par étage. Logistique urbaine optimisée en centre de Paris.",
  },
  {
    name: "Chantier neuf — Villemoisson-sur-Orge",
    location: "Villemoisson (91)",
    type: "Résidentiel · Gros œuvre",
    surface: "Platelage · Planchers",
    image: "/assets/chantier-platelage.jpg",
    gallery: ["/assets/chantier-platelage.jpg", "/assets/chantier-plancher.jpg", "/assets/chantier-structure.jpg"],
    tag: "Réalisé",
    description: "Platelage des poutres, étaiement et coulage des planchers béton. Coordination étroite avec le maître d'œuvre.",
  },
];

export const INTERVENTION_AREAS = [
  { code: "75", name: "Paris" },
  { code: "77", name: "Seine-et-Marne" },
  { code: "78", name: "Yvelines" },
  { code: "91", name: "Essonne" },
  { code: "92", name: "Hauts-de-Seine" },
  { code: "93", name: "Seine-Saint-Denis" },
  { code: "94", name: "Val-de-Marne" },
  { code: "95", name: "Val-d'Oise" },
];

export const STATS = [
  { value: "18", label: "Années d'expertise", suffix: "ans" },
  { value: "120+", label: "Chantiers livrés" },
  { value: "45", label: "Compagnons formés" },
  { value: "0", label: "Accident lost-time 2025" },
];
